import { Terminal } from "../../types/Terminal";

const GetTerminalOptions = (terminals: Terminal[]) => {
  if (!terminals?.length) {
    return [];
  }

  const terminalOptions = terminals.map(terminal => ({
    value: terminal['@id'],
    label: `${terminal.abbreviation ? `${terminal.abbreviation} - ` : ''}${terminal.name}`,
  }));

  const extractNum = (label: string): number | null => {
    const match = label.match(/(\d+)/);

    return match ? parseInt(match[1], 10) : null;
  };

  terminalOptions.sort((optionA, optionB) => {
    const labelNumberA = extractNum(optionA.label);
    const labelNumberB = extractNum(optionB.label);

    if (labelNumberA !== null && labelNumberB !== null) {
      if (labelNumberA !== labelNumberB) return labelNumberA - labelNumberB;

      return optionA.label.localeCompare(optionB.label);
    }

    if (labelNumberA !== null) return -1;
    if (labelNumberB !== null) return 1;

    return optionA.label.localeCompare(optionB.label);
  });

  return terminalOptions;
};
export default GetTerminalOptions;